// This file is auto-generated. Do not edit manually.
export const locationInfo: Record<string, Array<string>> = {
  "Drenthe": [
    "Assen",
    "Beilen",
    "Bovensmilde",
    "Coevorden",
    "Dalen",
    "Dalerpeel",
    "Eelde",
    "Eext",
    "Emmen",
    "Gasselte",
    "Gasselternijveen",
    "Gasselternijveenschemond",
    "Gieterveen",
    "Havelte",
    "Hoogeveen",
    "Huis ter Heide",
    "Klazienaveen",
    "Meppel",
    "Meppen",
    "Nieuw-Amsterdam",
    "Nieuw-Weerdinge",
    "Norg",
    "Oosterhesselen",
    "Paterswolde",
    "Peize",
    "Roden",
    "Rolde",
    "Ruinen",
    "Ruinerwold",
    "Schoonebeek",
    "Schoonoord",
    "Sleen",
    "Westerbork",
    "Zuidlaren",
    "Zwartemeer"
  ],
  "Flevoland": [
    "Almere",
    "Dronten",
    "Emmeloord",
    "Kraggenburg",
    "Lelystad"
  ],
  "Friesland": [
    "Dronryp",
    "Heerenveen",
    "Leeuwarden",
    "Sneek",
    "Unknown",
    "Wyns"
  ],
  "Fryslân": [
    "Akkrum",
    "Bakkeveen",
    "Balk",
    "Beetsterzwaag",
    "Berltsum",
    "Boelenslaan",
    "Bolsward",
    "Burdaard",
    "Burgum",
    "Damwâld",
    "Dokkum",
    "Drachten",
    "Drogeham",
    "Easterein",
    "Feanwâlden",
    "Ferwert",
    "Franeker",
    "Grou",
    "Heerenveen",
    "Hempens",
    "Hurdegaryp",
    "Joure",
    "Koudum",
    "Leeuwarden",
    "Lemmer",
    "Menaam",
    "Oldeberkoop",
    "Oosterwolde",
    "Oosterwolde FR",
    "Oudebildtzijl",
    "Oudeschoot",
    "Parrega",
    "Sneek",
    "St.-Annaparochie",
    "Sumar",
    "Surhuisterveen",
    "Ureterp",
    "Woudsend"
  ],
  "Gelderland": [
    "'s-Heerenberg",
    "Afferden",
    "Apeldoorn",
    "Arnhem",
    "Baak",
    "Barneveld",
    "Beekbergen",
    "Beneden-Leeuwen",
    "Beuningen Gld",
    "Borculo",
    "Bruchem",
    "Brummen",
    "Buren",
    "Culemborg",
    "Didam",
    "Dieren",
    "Doetinchem",
    "Doornspijk",
    "Duiven",
    "Ede",
    "Eerbeek",
    "Eibergen",
    "Epe",
    "Ermelo",
    "Gaanderen",
    "Garderen",
    "Gendringen",
    "Gorssel",
    "Groesbeek",
    "Harderwijk",
    "Harskamp",
    "Hattem",
    "Hengelo (Gld)",
    "Kerkdriel",
    "Kesteren",
    "Klarenbeek",
    "Lent",
    "Loenen Gld",
    "Lunteren",
    "Malden",
    "Neede",
    "Nijkerk",
    "Nijmegen",
    "Randwijk",
    "Ruurlo",
    "Scherpenzeel",
    "Silvolde",
    "Tiel",
    "Twello",
    "Ugchelen",
    "Ulft",
    "Unknown",
    "Varsselder",
    "Velp",
    "Velp Gld",
    "Voorthuizen",
    "Vorden",
    "Wageningen",
    "Wamel",
    "Warnsveld",
    "Wekerom",
    "Wijchen",
    "Winterswijk",
    "Zaltbommel",
    "Zetten",
    "Zevenaar",
    "Zutphen"
  ],
  "Groningen": [
    "Appingedam",
    "Delfzijl",
    "Groningen",
    "Haren",
    "Harkstede",
    "Hoogezand",
    "Leens",
    "Marum",
    "Oude Pekela",
    "Sappemeer",
    "Scheemda",
    "Schildwolde",
    "Stadskanaal",
    "Uithuizen",
    "Veendam",
    "Vlagtwedde",
    "Westerlee",
    "Wildervank",
    "Winschoten",
    "Winsum",
    "Zuidbroek",
    "Zuidwolde"
  ],
  "Limburg": [
    "Aachen",
    "Amstenrade",
    "Beek",
    "Berg en Terblijt",
    "Born",
    "Brunssum",
    "Buchten",
    "Cadier en Keer",
    "Castenray",
    "Echt",
    "Eijsden",
    "Elsloo",
    "Geleen",
    "Gennep",
    "Geulle",
    "Grashoek",
    "Grevenbicht",
    "Gronsveld",
    "Grubbenvorst",
    "Gulpen",
    "Heerlen",
    "Heeze",
    "Heijen",
    "Helden",
    "Herkenbosch",
    "Herten",
    "Heythuysen",
    "Hoensbroek",
    "Holtum",
    "Horst",
    "Kerkrade",
    "Kessel",
    "Klimmen",
    "Landgraaf",
    "Limbricht",
    "Linne",
    "Maasbracht",
    "Maastricht",
    "Meerssen",
    "Meijel",
    "Munstergeleen",
    "Nederweert",
    "Nuth",
    "Obbicht",
    "Ohe en Laak",
    "Ohé en Laak",
    "Posterholt",
    "Roermond",
    "Schinveld",
    "Sevenum",
    "Sint Joost",
    "Sittard",
    "Spaubeek",
    "Stein",
    "Steyl",
    "Swalmen",
    "Tegelen",
    "Urmond",
    "Vaals",
    "Valkenburg",
    "Velden",
    "Venlo",
    "Venray",
    "Vijlen",
    "Voerendaal",
    "Weert",
    "Wijlre",
    "Wijnandsrade",
    "Wittem",
    "Ysselsteyn"
  ],
  "Noord-Brabant": [
    "'s-Gravenmoer",
    "'s-Hertogenbosch",
    "Bergen Op Zoom",
    "Berkel-Enschot",
    "Best",
    "Bladel",
    "Bochum",
    "Boskant",
    "Boxmeer",
    "Boxtel",
    "Breda",
    "Cromvoirt",
    "Cuijk",
    "Den Bosch",
    "Den Dungen",
    "Diessen",
    "Dongen",
    "Dorst",
    "Eindhoven",
    "Etten-Leur",
    "Geertruidenberg",
    "Geffen",
    "Geldrop",
    "Goirle",
    "Grave",
    "Halsteren",
    "Heesch",
    "Heeze",
    "Helmond",
    "Helvoirt",
    "Herpen",
    "Heusden",
    "Hilvarenbeek",
    "Hoogerheide",
    "Katwijk",
    "Maarheeze",
    "Macharen",
    "Moergestel",
    "Molenschot",
    "Nijnsel",
    "Nuenen",
    "Oirschot",
    "Oisterwijk",
    "Oosterhout",
    "Oosterhout NB",
    "Oploo",
    "Oss",
    "Ossendrecht",
    "Oud Gastel",
    "Prinsenbeek",
    "Raamsdonk",
    "Raamsdonksveer",
    "Ravenstein",
    "Reek",
    "Riel",
    "Rijen",
    "Rijsbergen",
    "Roosendaal",
    "Rosmalen",
    "Schaijk",
    "Schijndel",
    "Sint Anthonis",
    "Sint Willebrord",
    "Sint-Oedenrode",
    "Someren",
    "Son en Breugel",
    "Sprang-Capelle",
    "Sprundel",
    "Steenbergen",
    "Terheijden",
    "Teteringen",
    "Tilburg",
    "Uden",
    "Udenhout",
    "Ulvenhout",
    "Valkenswaard",
    "Veghel",
    "Veldhoven",
    "Vlijmen",
    "Vorstenbosch",
    "Vught",
    "Waalre",
    "Waalwijk",
    "Waspik",
    "Wernhout",
    "Wouw",
    "Zevenbergen",
    "Zevenbergschen Hoek",
    "Zundert"
  ],
  "Noord-Holland": [
    "'t Zand",
    "AMSTERDAM",
    "Aalsmeer",
    "Aalsmeerderbrug",
    "Abbekerk",
    "Aerdenhout",
    "Alkmaar",
    "Amstelveen",
    "Andijk",
    "Anna Paulowna",
    "Avenhorn",
    "Badhoevedorp",
    "Bennebroek",
    "Bentveld",
    "Bergen",
    "Bergen NH",
    "Bergen aan Zee",
    "Blaricum",
    "Blokker",
    "Bovenkarspel",
    "Broek in Waterland",
    "Bussum",
    "Castricum",
    "Cruquius",
    "De Goorn",
    "Den Burg",
    "Den Helder",
    "Den Hoorn",
    "Den Oever",
    "Diemen",
    "Duivendrecht",
    "Edam",
    "Egmond aan Zee",
    "Egmond aan den Hoef",
    "Enkhuizen",
    "Grootebroek",
    "Haarlem",
    "Halfweg",
    "Heemskerk",
    "Heemstede",
    "Heerhugowaard",
    "Heiloo",
    "Hem",
    "Hensbroek",
    "Hilversum",
    "Hippolytushoef",
    "Hoofddorp",
    "Hoogkarspel",
    "Hoogwoud",
    "Hoorn",
    "Hoorn (NH)",
    "Huizen",
    "IJmuiden",
    "Koog aan de Zaan",
    "Laren",
    "Limmen",
    "Lisserbroek",
    "Loosdrecht",
    "Lutjebroek",
    "Medemblik",
    "Middelie",
    "Middenbeemster",
    "Midwoud",
    "Monnickendam",
    "Muiden",
    "Naarden",
    "Nieuw-Vennep",
    "Nieuwe Niedorp",
    "Noord-Scharwoude",
    "Obdam",
    "Oosterblokker",
    "Oosthuizen",
    "Opmeer",
    "Opperdoes",
    "Ouderkerk aan de Amstel",
    "Oudorp",
    "Purmerend",
    "Rijsenhout",
    "Schagen",
    "Schardam",
    "Schermerhorn",
    "Schoorl",
    "Sint Maarten",
    "Sint Maartensbrug",
    "Sint Pancras",
    "Spanbroek",
    "Stompetoren",
    "Twisk",
    "Uitgeest",
    "Uithoorn",
    "Ursem",
    "Velserbroek",
    "Venhuizen",
    "Vijfhuizen",
    "Volendam",
    "Warmenhuizen",
    "Watergang",
    "Weesp",
    "Wervershoof",
    "Wieringerwerf",
    "Wijdenes",
    "Wognum",
    "Wormer",
    "Wormerveer",
    "ZAANDAM",
    "Zaandijk",
    "Zandvoort",
    "Zuid-Scharwoude",
    "Zuidoostbeemster",
    "Zwaag"
  ],
  "Overijssel": [
    "Almelo",
    "Bathmen",
    "Beerze",
    "Bruinehaar",
    "De Lutte",
    "Deventer",
    "Diepenveen",
    "Eindhoven",
    "Enschede",
    "Genemuiden",
    "Hardenberg",
    "Hasselt",
    "Heino",
    "Hengelo",
    "Hertme",
    "Holten",
    "IJsselmuiden",
    "Kampen",
    "Kloosterhaar",
    "Nieuwleusen",
    "Nijverdal",
    "Oldenzaal",
    "Ommen",
    "Raalte",
    "Rouveen",
    "Slagharen",
    "Smeermaas",
    "Steenwijk",
    "Veldwezelt",
    "Vilsteren",
    "Vollenhove",
    "Vroomshoop",
    "Wijhe",
    "Zwartsluis",
    "Zwolle"
  ],
  "Utrecht": [
    "AUSTERLITZ",
    "Abcoude",
    "Amersfoort",
    "Baarn",
    "Bilthoven",
    "Breukelen",
    "De Bilt",
    "De Meern",
    "Doorn",
    "Driebergen-Rijsenburg",
    "Eemdijk",
    "Harmelen",
    "Hoogland",
    "Houten",
    "IJsselstein",
    "Langbroek",
    "Maarn",
    "Maarssen",
    "Mijdrecht",
    "Nieuwegein",
    "Nieuwersluis",
    "Oud-Zuilen",
    "Oudewater",
    "Rhenen",
    "Soest",
    "Soesterberg",
    "UTRECHT",
    "Veenendaal",
    "Vianen",
    "Vinkeveen",
    "Vleuten",
    "Woerden",
    "ZEIST"
  ],
  "Zeeland": [
    "'s-Heer Arendskerke",
    "'s-Heerenhoek",
    "Axel",
    "Brouwershaven",
    "Bruinisse",
    "Dreischor",
    "Goes",
    "Heinkenszand",
    "IJzendijke",
    "Kamperland",
    "Kapelle",
    "Kerkwerve",
    "Kruiningen",
    "Middelburg",
    "Nieuwdorp",
    "Nieuwerkerk",
    "Oost-Souburg",
    "Ovezande",
    "Sas Van Gent",
    "Serooskerke (Walcheren)",
    "Serooskerke Walcheren",
    "Sint-Annaland",
    "Terneuzen",
    "Tholen",
    "Vlissingen",
    "Wemeldinge",
    "Wolphaartsdijk",
    "Yerseke",
    "Zierikzee"
  ],
  "Zuid-Holland": [
    "'S-GRAVENHAGE",
    "'s-Gravendeel",
    "Alphen aan den Rijn",
    "Barendrecht",
    "Bergambacht",
    "Berkel en Rodenrijs",
    "Bodegraven",
    "Boskoop",
    "Brielle",
    "Capelle Aan Den Ijssel",
    "Capelle aan den Iijssel",
    "DEN HAAG",
    "De Lier",
    "Delfgauw",
    "Delft",
    "Den Bommel",
    "Den Hoorn",
    "Dirksland",
    "Dordrecht",
    "Goedereede",
    "Gouda",
    "HENDRIK-IDO-AMBACHT",
    "Haastrecht",
    "Hardinxveld-Giessendam",
    "Hellevoetsluis",
    "Hillegom",
    "Hoek",
    "Honselersdijk",
    "Katwijk",
    "LEIDEN",
    "Leiderdorp",
    "Leidschendam",
    "Leimuiden",
    "Lisse",
    "Maassluis",
    "Middelharnis",
    "Monster",
    "Naaldwijk",
    "Nieuwe-Tonge",
    "Noordwijk",
    "Noordwijkerhout",
    "Nootdorp",
    "Oegstgeest",
    "Ooltgensplaat",
    "Oud-Beijerland",
    "Ouddorp",
    "Ouderkerk aan den IJssel",
    "Papendrecht",
    "Pijnacker",
    "Poeldijk",
    "RIJSWIJK",
    "ROTTERDAM",
    "Reeuwijk",
    "Rhoon",
    "Ridderkerk",
    "Rijnsburg",
    "Rijswijk ZH",
    "Roelofarendsveen",
    "Sassenheim",
    "Schiedam",
    "Sliedrecht",
    "Sommelsdijk",
    "Spijkenisse",
    "The Hague",
    "Valkenburg",
    "Vlaardingen",
    "Voorburg",
    "Voorhout",
    "Voorschoten",
    "Waddinxveen",
    "Warmond",
    "Wassenaar",
    "Wateringen",
    "Zoetermeer",
    "Zoeterwoude",
    "Zuidland",
    "Zwijndrecht"
  ]
};